import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import store from "../store";
import jwtDecode from "jwt-decode";
import Auth from "@/plugins/aws-amplify";
import moment from "moment";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "Channel",
    component: () => import("@/views/Channel"),
    meta: { requireAuth: false }
  },
  {
    path: "/authentication",
    component: () => import("@/layouts/blank-layout/Blanklayout"),
    children: [
      {
        name: "SignIn",
        path: "signin",
        component: () => import("@/views/authentication/SignIn"),
        meta: { requireAuth: false }
      },
      {
        name: "SignOut",
        path: "signout",
        component: () => import("@/views/authentication/SignOut"),
        meta: { requireAuth: false }
      },
      {
        name: "Error404",
        path: "error404",
        component: () => import("@/views/authentication/Error404"),
        meta: { requireAuth: false }
      },
      {
        name: "Error401",
        path: "error401",
        component: () => import("@/views/authentication/Error401"),
        meta: { requireAuth: false }
      },
      {
        name: "Error403",
        path: "error403",
        component: () => import("@/views/authentication/Error403"),
        meta: { requireAuth: false }
      },
      {
        name: "ErrorLicense",
        path: "errorlicense",
        component: () => import("@/views/authentication/ErrorLicense"),
        meta: { requireAuth: false }
      }
    ]
  },
  {
    path: "/:id",
    redirect: "/:id/dashboards",
    component: () => import("@/layouts/full-layout/Layout"),
    children: [
      {
        name: "Dashboards",
        path: "dashboards",
        component: () => import("@/views/Dashboards"),
        meta: { requireAuth: true, roles: ["service#sa"] }
      },
      {
        name: "Users",
        path: "users",
        component: () => import("@/views/Users"),
        meta: { requireAuth: true, roles: ["service#sa"] }
      },
      {
        name: "Groups",
        path: "groups",
        component: () => import("@/views/Groups"),
        meta: { requireAuth: true, roles: ["service#sa"] }
      },
      {
        name: "Events",
        path: "events",
        component: () => import("@/views/Events"),
        meta: { requireAuth: true, roles: ["service#sa"] }
      },
      {
        name: "Contents",
        path: "contents",
        component: () => import("@/views/Contents"),
        meta: { requireAuth: true, roles: ["service#sa"] }
      },
      {
        name: "Content",
        path: "content",
        component: () => import("@/views/ContentEdit"),
        meta: { requireAuth: true, roles: ["service#sa"] }
      },
      {
        name: "Collections",
        path: "collections",
        component: () => import("@/views/Collections"),
        meta: { requireAuth: true, roles: ["service#sa"] }
      },
      {
        name: "Collection",
        path: "collection",
        component: () => import("@/views/CollectionEdit"),
        meta: { requireAuth: true, roles: ["service#sa"] }
      },
      {
        name: "UploadTest",
        path: "uploadtest",
        component: () => import("@/views/UploadTest"),
        meta: { requireAuth: true, roles: ["service#sa"] }
      }
    ]
  },
  {
    path: "*",
    redirect: { name: "Error404" }
  }
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  }
});

router.beforeEach(async (to, from, next) => {
  console.log("[Router] beforeEach Start");
  console.log("[Router]", { from, to, next });
  // Progress bar
  //  does the page we want to go to have a meta.progress object
  if (to.meta.progress !== undefined) {
    let meta = to.meta.progress;
    // parse meta tags
    Vue.prototype.$Progress.parseMeta(meta);
  }
  //  start the progress bar
  Vue.prototype.$Progress.start();
  //  continue to next page

  // 로그인 상태 가져와 기본사항 체크
  const user = store.state.user;
  let idToken;
  await Auth.currentAuthenticatedUser()
    .then(currentUser => {
      // 사용자 정보를 state에 저장.
      idToken = currentUser.signInUserSession.idToken.jwtToken;
      // console.log("[Router] Current Authenticated User ", idToken);
    })
    .catch(() => {
      console.log("[Router] No Current Authenticated User");
      store.commit("SET_USER", null);
    });

  // const idToken = user ? user.idToken : null;
  const idTokenDecoded = idToken
    ? jwtDecode(idToken)
    : { "cognito:groups": [] };
  const channel = store.state.channel;
  const channelId = store.state.channelId;
  const userInfo = store.state.user;

  console.log("[Router] 기본정보", { channel, channelId, userInfo });

  if (channel && idToken) {
    console.log(
      "[Router] 채널정보와 아이디토큰을 이용해 채널라이센스 유효여부 확인",
      { user, idToken, channelId, license: channel.licenses }
    );

    const validLicenses = channel.licenses.filter(lic => {
      const n = moment();
      const s = moment(lic.start);
      const e = moment(lic.end);
      return lic.mode == "basic" && n >= s && e >= n;
    });

    if (channelId && (!channel.licenses || validLicenses.length < 1)) {
      store.commit("SET_CHANNEL_ID", null);
      store.commit("SET_CHANNEL", null);
      store.dispatch("signOutWithOutMoving");
      return next({ name: "ErrorLicense" });
    }
  }

  // 권한검증이 필요 없으면 진행
  if (!to.meta.requireAuth) {
    console.log("[Router] 권한검증 필요한 메뉴인지 확인");
    try {
      return next();
    } catch (e) {
      console.log(e);
    }
  }

  // 권한이 필요한데 로그인상태가 아니면 사인인으로
  if (!user || !idToken) {
    console.log("[Router] 권한이 필요한데 로그인상태가 아니면 사인인으로");
    return next({
      name: "SignIn",
      query: { redirect: to.fullPath }
    });

    // const toPath = to.fullPath;
    // const path =
    //   toPath.charAt(0) == "/" ? toPath.substr(1, toPath.length - 1) : toPath;
    // const url =
    //   process.env.VUE_APP_BASE_URL +
    //   "/auth/signin?redirect=" +
    //   "http://" +
    //   window.location.host +
    //   process.env.VUE_APP_PUBLIC_PATH +
    //   path;

    // window.location.href = url;
    // return null;
  }

  // 로그인은 했는데 역할 제한이 없으면 진행
  if (!to.meta.roles) {
    console.log("[Router] 로그인은 했는데 역할 제한이 없으면 진행");
    return next();
  }

  // 로그인을 했고 역할이 맞으면 진행
  if (
    Array.isArray(idTokenDecoded["cognito:groups"]) &&
    idTokenDecoded["cognito:groups"].some(
      elem =>
        to.meta.roles.includes(elem) || elem == `${store.state.channelId}#cm`
    )
  ) {
    console.log("[Router] 로그인을 했고 역할이 맞으면 진행");
    return next();
  }

  // 로그인은 했으나 역할이 안 맞으면
  console.log("[Router] 로그인은 했으나 역할이 안 맞으면");
  Vue.notify({
    group: "Auth",
    title: "Access Denied"
  });
  router.push({ name: "Error403" });
});

// This is for the scroll top when click on any router link

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
  //  finish the progress bar
  console.log("[Router] beforeEach End / afterEach run");
  Vue.prototype.$Progress.finish();
});
export default router;
